import { render, staticRenderFns } from "./PluginLoading.vue?vue&type=template&id=c0fa1bc6"
import script from "./PluginLoading.vue?vue&type=script&lang=js"
export * from "./PluginLoading.vue?vue&type=script&lang=js"
import style0 from "./PluginLoading.vue?vue&type=style&index=0&id=c0fa1bc6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0fa1bc6')) {
      api.createRecord('c0fa1bc6', component.options)
    } else {
      api.reload('c0fa1bc6', component.options)
    }
    module.hot.accept("./PluginLoading.vue?vue&type=template&id=c0fa1bc6", function () {
      api.rerender('c0fa1bc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plugin/PluginLoading.vue"
export default component.exports